export default "__VITE_PUBLIC_ASSET__2af0fd5f__"